export const normalizedPercentage = (percentage: number) => {
  // El campo "% Bono" siempre recibe un porcentaje (1, 2, 3.5...), nunca una
  // fracción. Se convierte a fracción dividiendo entre 100 de forma
  // consistente (una heurística por magnitud rompía valores <= 1, p. ej. 1%).
  return percentage / 100;
};

export const toDisplayPercentage = (percentage: number) => {
  return parseFloat(((percentage ?? 0) * 100).toFixed(2)).toString();
};

export const calculateBonusAmount = ({
  minPrice,
  percentage,
  country,
  publicationPrice,
}: {
  country: "CO" | "MX";
  minPrice: number;
  percentage: number;
  publicationPrice: number;
}): number => {
  const basePrice =
    minPrice && minPrice > 0 ? minPrice : publicationPrice * 0.97;

  const rawAmount = normalizedPercentage(percentage) * basePrice;

  if (country === "CO") {
    return Math.floor(rawAmount / 10000) * 10000;
  }

  if (country === "MX") {
    return Math.floor(rawAmount / 100) * 100;
  }

  return 0;
};
